import { createReduxSlice } from 'app/app/(client)/redux/ReduxSlice'
import { State } from 'app/types/redux-types'
import { SyncStatus } from 'app/types/types'

const initialState: State<Record<string, SyncStatus>> = {
  data: {},
  status: 'idle',
  error: null
}

const currentSyncSlice = createReduxSlice({
  name: 'currentSync',
  initialState
})

export const { setData: setCurrentSync } = currentSyncSlice.actions
export default currentSyncSlice.reducer
